import { Fields } from 'korint-sdk/react';
import { FieldError, useFormContext } from 'react-hook-form';
import { Alert } from '../ui';

export function ComputedFieldsFormErrors({ fields }: Readonly<{ fields: Fields }>) {
  const form = useFormContext();

  const computedFields = fields.filter(field => field.type === 'computed');
  const computedFieldsErrors = computedFields.reduce(
    (acc, field) => {
      const error = form.formState.errors[field.name];
      if (error !== undefined) {
        acc.push({ message: (error as FieldError).message ?? '', fieldName: field.name });
      }
      return acc;
    },
    [] as { message: string; fieldName: string }[],
  );

  if (computedFieldsErrors.length === 0) {
    return null;
  }

  return (
    <Alert variant="destructive">
      {computedFieldsErrors.map(({ fieldName, message }) => (
        <div key={fieldName}>{message}</div>
      ))}
    </Alert>
  );
}
